import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useSkillFilter = (talentFilter, talentFilterTags, skillLabelMap) => {
  const [selectedSkills, setSelectedSkills] = useState([]);

  useEffect(() => {
    if (talentFilter?.skills?.list) {
      setSelectedSkills(talentFilter.skills.list);
    }
  }, []);

  useEffect(() => {
    if (!talentFilter || Object.keys(talentFilter).length === 0) {
      setSelectedSkills([]);
    }
  }, [talentFilter]);

  const buildSkillFilter = () => {
    if (!selectedSkills.length) return null;

    const skillsPayload = {
      has_all_in_list: true,
      list: selectedSkills,
    };

    const skillNames = selectedSkills.map(id => skillLabelMap[id]);

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.skills,
      skillNames
    );

    return { skillsPayload, tags };
  };

  return {
    selectedSkills,
    setSelectedSkills,
    buildSkillFilter,
  };
};
